const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls, useArrows } =
  window.BAO.Carousel.plugins

class ProductCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 2.1,
          spacing: 8,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.3,
              spacing: 8,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3,
              spacing: 8,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 4,
              spacing: 8,
            },
          },
        },
      },
      [
        setInitialised(),
        addWheelControls('horizontal'),
        useArrows({
          next: this.externalEls?.next?.element,
          previous: this.externalEls?.previous?.element,
        }),
      ],
    )
  }
}

if (!customElements.get('product-carousel')) {
  customElements.define('product-carousel', ProductCarousel)
}
